export enum FORMULAR_STATUS {
  NO_REQUEST,
  CALCULATING_CAPTCHA,
  SENDING_REQUEST,
  FORMULAR_FINISHED,
}

export enum REGISTER_FORM_EMAIL_STATUS {
  NO_VALID_MAIL,
  INTERNAL_MAIL,
  EXTERNAL_MAIL,
}
